import React, { useMemo } from 'react';
import { useLaborCostDashboardStore } from 'pages/ReportsPage/components/AnalyticsDashboards/LaborCostDashboard/store/laborCostDashboard.store';
import { createHeatMapColorScale } from 'pages/ReportsPage/components/AnalyticsDashboards/chartColors';
import { HeatMapGrid } from 'pages/ReportsPage/components/AnalyticsDashboards/FulfillmentDashboard/HeatMapGrid';
import { EmptyStateContainer } from 'pages/ReportsPage/components/AnalyticsDashboards/LaborCostDashboard/LaborCostDashboard.styled';
import {
  TIMEFRAMES,
  DAYS_OF_WEEK,
  CALLOUT_TIMEFRAME_HEATMAP_COLOR,
} from 'pages/ReportsPage/components/AnalyticsDashboards/LaborCostDashboard/LaborCostDashboard.constants';

function buildHeatMapMatrix(
  cells: { timeframe: string; dayOfWeek: string; shiftCount: number }[],
  rowLabels: readonly string[],
  colLabels: readonly string[],
): number[][] {
  const lookup = new Map(cells.map((c) => [`${c.timeframe}-${c.dayOfWeek}`, c.shiftCount]));
  return rowLabels.map((row) => colLabels.map((col) => lookup.get(`${row}-${col}`) ?? 0));
}

export const CalloutTimeframeChart: React.FC = () => {
  const data = useLaborCostDashboardStore((s) => s.calloutTimeframeCells);

  const matrix = useMemo(
    () => (data ? buildHeatMapMatrix(data, TIMEFRAMES, DAYS_OF_WEEK) : []),
    [data],
  );

  const colorScale = useMemo(() => createHeatMapColorScale(CALLOUT_TIMEFRAME_HEATMAP_COLOR), []);

  if (!data) {
    return <EmptyStateContainer>No data available</EmptyStateContainer>;
  }

  return (
    <HeatMapGrid
      rowLabels={[...TIMEFRAMES]}
      columnLabels={[...DAYS_OF_WEEK]}
      data={matrix}
      colorScale={colorScale}
      valueFormatter={(v) => `${v} shifts`}
      ariaLabel="Most common timeframe to start the call out shifts heat map"
    />
  );
};
